import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to top whenever the URL pathname changes. */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    // Disable browser scroll restoration so it does not fight us.
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
